import React from 'react';
import { NavBar } from '../../../Modules/Navigation/components/NavBar/NavBar';
import PageContentCardContainer from '../../../ui/Layout/PageContentCardContainer/PageContentCardContainer';
import styles from './TrendingTiktokAudioSuggestionsPage.module.css';
import TrendingAudioSuggestions from '../../../Modules/TikTok/trendingAudios/features/TrendingAudioSuggestions/TrendingAudioSuggestions';

const TrendingTiktokAudioSuggestionsPage = () => (
    <>
        <NavBar />
        <PageContentCardContainer>
            <h1 className={styles.title}>Trending Audios</h1>
            <TrendingAudioSuggestions />
        </PageContentCardContainer>
    </>
);

export default TrendingTiktokAudioSuggestionsPage;
